import script from "./EditAutomationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditAutomationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./EditAutomationDialog.vue?vue&type=style&index=0&id=9c52e850&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c52e850"]])